import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "index",
    component: Index,
  },
  // 首页
  {
    path: "/home",
    name: "home",
    component: () => import("../views/home.vue"),
  },
  // 
  {
    path: "/about",
    name: "about",
    component: () => import("../views/about.vue"),
  },
  // 
  {
    path: "/core",
    name: "core",
    component: () => import("../views/core.vue"),
  },
  // 
  {
    path: "/product",
    name: "product",
    component: () => import("../views/product.vue"),
  },
  // 
  {
    path: "/quality",
    name: "quality",
    component: () => import("../views/quality.vue"),
  },
  // 关于数港
  {
    path: "/crane",
    name: "crane",
    component: () => import("../views/crane.vue"),
  },
  // 联系我们
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/contact.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
